import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddBenefitAdjustmentRequestBody } from '@/domains/payments/features/paymentModals/modals/adjustments/types/requests/AddBenefitAdjustmentRequestBody';
import { AddPaymentAdjustmentRequestBody } from '@/domains/payments/features/paymentModals/modals/adjustments/types/requests/AddPaymentAdjustmentRequestBody';

type AddAdjustmentSliceInitialState = {
  addAdjustmentIsLoading: boolean;
};

const initialState: AddAdjustmentSliceInitialState = {
  addAdjustmentIsLoading: false,
};

const addAdjustmentSlice = createSlice({
  name: 'addAdjustmentSlice',
  initialState,
  reducers: {
    addPaymentAdjustment(state, _action: PayloadAction<AddPaymentAdjustmentRequestBody & { claimId: number }>) {
      state.addAdjustmentIsLoading = true;
    },
    addBenefitAdjustment(state, _action: PayloadAction<AddBenefitAdjustmentRequestBody & { claimId: number }>) {
      state.addAdjustmentIsLoading = true;
    },
    addAdjustmentSuccess(state) {
      state.addAdjustmentIsLoading = false;
    },
    addAdjustmentError(state) {
      state.addAdjustmentIsLoading = false;
    },
  },
});

export const { addPaymentAdjustment, addBenefitAdjustment, addAdjustmentSuccess, addAdjustmentError } =
  addAdjustmentSlice.actions;

export const addAdjustmentReducer = addAdjustmentSlice.reducer;
export const addAdjustmentReducerPath = addAdjustmentSlice.reducerPath;
